import React, { memo } from 'react';
import styled from 'styled-components';

import { toRem } from '@front/common/src/utils/styles';

import { translate } from '@front/i18n';

import LoadingSpinner from '../loading-spinner/loading-spinner';

const t = translate('components.loader');

const Container = styled.div`
  display: flex;
  width: 100%;
  padding: ${toRem(100)} 0;
  align-items: center;
  justify-content: center;
`;

const ScreenLoader = () => (
  <Container>
    <LoadingSpinner size={128} title={t('.loading')} />
  </Container>
);

export default memo(ScreenLoader);
